<template>
    <thead>
        <tr>
            <th colspan="16">Drinkware Summary</th>
        </tr>
        <tr class="table-titles">
            <th colspan="2">Date</th>
            <th colspan="2"><img src="@/assets/images/11oz-Mug.svg" alt="" width=30 /></th>
            <th colspan="2"><img src="@/assets/images/15oz-Mug.svg" alt="" width=30 /></th>
            <th colspan="2"><img src="@/assets/images/Steel-Mug.svg" alt="" width=30 /></th>
            <th colspan="2"><img src="@/assets/images/Special-Mug.svg" alt="" width=30 /></th>
            <th colspan="2"><img src="@/assets/images/Steel-Bottle.svg" alt="" width=30 /></th>
            <th colspan="2">TOTAL ORDERS</th>
        </tr>
        <tr class="item-action">
            <th colspan="2"></th>
            <th class="in" colspan="1">IN</th>
            <th class="out border-left" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
        </tr>
    </thead>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    name: "TitleTable",
    components: {}
});
</script>

<style lang="scss" scoped>
</style>